/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class KubernetesCostSpendByDimensionWidgetConfiguration extends models.BaseDimensionWidgetConfiguration {
    constructor() {
        super();
        this.setDiscriminator("KubernetesCostSpendByDimensionWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return KubernetesCostSpendByDimensionWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<KubernetesCostSpendByDimensionWidgetConfiguration>): KubernetesCostSpendByDimensionWidgetConfiguration {
        let obj = Object.assign(new KubernetesCostSpendByDimensionWidgetConfiguration(), model);
        KubernetesCostSpendByDimensionWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<KubernetesCostSpendByDimensionWidgetConfiguration>): KubernetesCostSpendByDimensionWidgetConfiguration {
        if (!model) return null;
        return KubernetesCostSpendByDimensionWidgetConfiguration.newInstance(<KubernetesCostSpendByDimensionWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: KubernetesCostSpendByDimensionWidgetConfiguration) {
        if (!obj) return;

        models.KubernetesCostSpendByDimensionWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: KubernetesCostSpendByDimensionWidgetConfiguration): boolean {
        if (models.BaseDimensionWidgetConfiguration.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, KubernetesCostSpendByDimensionWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    selectedAccountId: string;

    /**
     * Metric the widget reports per dimension: cost, usage or rate. Usage and rate apply to the AI platform only, and require a Consumed Unit filter pinning a single billing unit
     */
    primaryMetric: string;

    /**
     * Platform this widget reports cost data for
     */
    platform: models.Platforms;

}
